import React from 'react';
import type { AuthSession } from './useAuthSession';

export type AuthScreen = 'sign_in' | 'email_input' | 'otp_input';

export interface AuthContextValue {
  screen: AuthScreen;
  setScreen: (screen: AuthScreen) => void;
  email: string;
  setEmail: (email: string) => void;
  session: AuthSession;
}

export const AuthContext = React.createContext<AuthContextValue | null>(null);

export function useAuthContext(): AuthContextValue {
  const ctx = React.useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuthContext must be used inside FsAuthenticator');
  }
  return ctx;
}
